import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormGenerator from '../../../Cells/Form/FormGenerator';
import { STEP_KEYS } from '../../../../Store/Slices/StepForm';
import './styles.css';

const ReviewOpenEnrollment = (props) => {
  const dispatch = useDispatch();
  const { currentLanguage } = useSelector(({ language }) => language);
  const employeeProfile = useSelector(({ employeeProfile }) => employeeProfile);
  const insuredInfo = useSelector(({ insuredInfo }) => insuredInfo);
  const registerationError = useSelector(({ registerationError }) => registerationError);
  const [content, setContent] = useState([]);
  const [layoutData, setLayoutData] = useState([]);
  const { loggedUserEntity: { data: dataFromRedux } = {} } = useSelector(({ auth }) => auth);
  const {
    dependentsList,
    dependentsInfo,
    dependentsBeneficiaryList = [],
  } = useSelector(({ employeeProfile }) => employeeProfile);

  useEffect(() => {
    import(`./Content/${currentLanguage}.json`)
      .then(module => setContent(module.default))
      .catch(error => console.error("Failed to load content:", error));
  }, [currentLanguage]);

  useEffect(() => {
    setLayoutData({
      ...dataFromRedux,
      dependentsList,
      dependentsInfo,
      dependentsBeneficiaryList,
    });
  }, []);

  const {
    layout: {
      ReviewOpenEnrollment = {},
      sectionHeader: { breadcrumbs = {}, title = '' } = {},
    } = {},
  } = content || {};

  const stepKeys = [
    'EmployeeProfile',
    'ProductSelection',
    'DependentInformation',
    'CoverageSelection',
    'IdTheft',
    'SupplementalHealthInsurance',
    'LegalCoverage',
    'Travel',
    'PetPlus',
    'PetAssure',
    'TotalPetPlan',
    'HospitalIndemnity',
    'CriticalIllness',
    'EnrollmentSummary',
  ];

  dispatch(STEP_KEYS({ stepKeys: stepKeys }));
  return (
    <Fragment>
      <FormGenerator content={content} layoutData={layoutData} />
    </Fragment>
  );
};

export default ReviewOpenEnrollment;
